// Title: header-searchbar.ts
//
// Author: Jacco van der Post <vanderpost@redkiwi.nl>
//
// Date: 21-03-2022
//

import { toggleClass } from "../utils";

/**
 * Open close header seachbar on desktop
 */
export class HeaderSearchbar {
    constructor() {
        // Open and close search bar buttons
        document.querySelectorAll(".searchbar-toggle").forEach((item) => {
            item.addEventListener("click", (event) => {
                event.preventDefault();

                // Show / hide searchbar on desktop
                toggleClass(
                    document.querySelector(".main-header"),
                    "lg-move-down"
                );
                toggleClass(document.querySelector("main"), "lg-move-down");

                // Focus on search field
                document.getElementById("header-search").focus();
            });
        });
    }
}
